<template src="./isi_2.html"></template>

<script>
export default {
  name: 'module-isi-2',
  data() {
    return {
      isActive: false
    };
  },
  methods: {
    toggleINDICATION() {
      this.$store.commit(
        'INDICATION_STATE',
        !this.$store.state.isIndicationActive
      );
      this.$store.commit('ISI_STATE', (this.$store.state.isActive = false));
    }
  }
};
</script>

<style lang="scss" src="./isi_2.scss">
</style>
